import type { AppSnmp } from '@ipfabric/utils';
import type { ApiHook } from 'utils/request/useApi';
import type { Snmp } from '../../SnmpModel';

export type SnmpResponse = {
  snmp: Snmp;
};

type SnmpPayload = Omit<AppSnmp, 'systemContact' | 'locality'> & {
  systemContact?: string | null;
  locality?: string | null;
};

export function patchSnmp(api: ApiHook, snmp: SnmpPayload) {
  return api.request<SnmpResponse>({
    url: '/settings',
    method: 'PATCH',
    data: {
      snmp,
    },
  });
}
